import { Warning, type Icon } from "@phosphor-icons/react";
import { Badge } from "@replicate/ui";

export function Label({
  Icon,
  name,
  required,
  type,
  deprecated,
}: {
  Icon?: Icon;
  name: string;
  required: boolean;
  type: string | null;
  deprecated: boolean | undefined;
}) {
  return (
    <div className="flex items-center gap-2">
      <label className="text-r8-base font-mono" htmlFor={name}>
        <div className="flex items-center gap-1.5" translate="no">
          {Icon ? <Icon aria-hidden size={14} /> : null}
          <span className={deprecated ? "text-r8-gray-11" : undefined}>
            {name}
          </span>
        </div>
      </label>
      {required && <span className="text-r8-red-10">*</span>}
      {type && (
        <span className="font-sans text-r8-sm text-r8-gray-11">{type}</span>
      )}
      {deprecated && (
        <Badge rounded size="sm" variant="danger" startIcon={<Warning />}>
          Deprecated
        </Badge>
      )}
    </div>
  );
}
